import React, { useRef } from 'react'
import { View } from 'react-native'
import Swiper from 'react-native-web-swiper'

import { useNavigation } from '@react-navigation/native'
import tw from 'tailwind-rn'
import styles from './styles'
import { HGText, HGButton } from '../../components/HGUI'
import CrossPlatformImage from '../../components/CrossPlatformImage'

const onboarding1 = require('../../../assets/img/onboarding/onboarding-1.png')
const onboarding1_2x = require('../../../assets/img/onboarding/onboarding-1_2x.png')
const onboarding1_3x = require('../../../assets/img/onboarding/onboarding-1_3x.png')
const onboarding4 = require('../../../assets/img/onboarding/onboarding-4.png')
const onboarding4_2x = require('../../../assets/img/onboarding/onboarding-4_2x.png')
const onboarding4_3x = require('../../../assets/img/onboarding/onboarding-4_3x.png')

const OnboardingSlider = () => {
  const navigation = useNavigation()
  const swiperRef = useRef(null)
  return (
    <Swiper
      from={0}
      minDistanceForAction={0.1}
      // containerStyle={tw('max-w-4xl')}
      controlsProps={{
        NextComponent: () => (
          <HGButton
            title="Weiter"
            size="small"
            onPress={() => swiperRef.current?.goToNext()}
            style={tw('mb-2')}
          />
        ),
        PrevComponent: () => (
          <HGButton
            title="Zurück"
            size="small"
            onPress={() => swiperRef.current?.goToPrev()}
            style={tw('mb-2')}
          />
        ),
      }}
      ref={swiperRef}
    >
      <View style={styles.slide}>
        <View style={[styles.slideInner, { marginTop: 0 }]}>
          <CrossPlatformImage
            source={onboarding1}
            source2x={onboarding1_2x}
            source3x={onboarding1_3x}
          />
          <HGText style={[styles.text, styles.textHeadline]}>
            Häusliche Gewalt in der Familie
          </HGText>
          <HGText style={styles.text}>
            Hans & Gretel dient als Hilfe bei der Feststellung und Dokumentation
            Häuslicher Gewalt und Gewalt in der Familie.
          </HGText>
        </View>
      </View>

      <View style={styles.slide}>
        <View style={styles.slideInner}>
          <View style={tw('mb-4')}>
            <CrossPlatformImage
              source={onboarding4}
              source2x={onboarding4_2x}
              source3x={onboarding4_3x}
            />
          </View>

          <HGText
            style={[
              styles.text,
              styles.textHeadline,
              styles.textHeadlineWithNoMargin,
            ]}
          >
            Wie kann ich vorgehen?
          </HGText>
          <HGText
            style={[
              styles.text,
              styles.textHeadline,
              styles.textHeadlineWithNoMargin,
            ]}
          >
            Wie dokumentiere ich?
          </HGText>
          <HGText
            style={[
              styles.text,
              styles.textHeadline,
              styles.textHeadlineWithNoMargin,
            ]}
          >
            Wohin wende ich mich?
          </HGText>
        </View>
      </View>

      <View style={styles.slide}>
        <View style={[styles.slideInner, tw('w-full')]}>
          <HGButton
            title="Jetzt registrieren"
            onPress={() => navigation.navigate('SignUp')}
            style={tw('w-full')}
          />

          <HGText style={[styles.text, styles.actionText]}>
            Bereits registriert?
          </HGText>

          <HGButton
            title="Anmelden"
            type="inverted"
            onPress={() => navigation.navigate('SignIn')}
            style={tw('w-full')}
          />
        </View>
      </View>
    </Swiper>

    // <Swiper
    //   style={[
    //     styles.sliderWrap,
    //     Platform.OS === 'android' && styles.sliderWrapAndroid,
    //   ]}
    //   loop={false}
    //   dotStyle={styles.dotStyle}
    //   activeDotStyle={styles.dotActiveStyle}
    // >
    // </Swiper>
  )
}

export default OnboardingSlider
